import Vue from 'vue';
import { i18n } from '@/plugins/i18n';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';


/**
 * Score based on the number of problems change over time.
 * Check the 3 latest periods : Score = number of completed - number of reported
 */
export default new VitalityCriterion({
  titleTr: 'VH_PB_RESOLUTION',
  key: 'problemResolution',
  weight: 2,

  score: ({ problems }, range, { currentRangeIndex, ranges, teams }) => {
    // Get the number of problems in the considered period
    const prevPeriodStartIdx = Math.min(currentRangeIndex + 3, ranges.length - 1);
    const prevRangeStart = ranges[prevPeriodStartIdx].start;
    const numberOfPeriods = prevPeriodStartIdx - currentRangeIndex;


    let nReported = 0;
    let nResolved = 0;
    for (let i = 0, len = problems.length; i < len; i++) {
      const { created, state, lastActionAct } = problems[i];
      const mDate = Vue.moment(created);
      if (prevRangeStart.isBefore(mDate) && range.start.isAfter(mDate)) {
        nReported++;
      }
      if (state === 4) {
        const mSolveDate = Vue.moment(lastActionAct);
        if (prevRangeStart.isBefore(mSolveDate) && range.start.isAfter(mSolveDate)) {
          nResolved++;
        }
      }
    }

    let score;
    if (nReported === 0) {
      score = 0;
    } else {
      score = nResolved * 100 / nReported;
    }

    return {
      score: score.sBetweenBoundaries(0, 100),
      data: {
        value: score,
        nReported,
        nResolved,
      },
    };
  },

  text({ value, nReported, nResolved }) {
    if (nReported === 0) {
      return i18n.t('message.VH_PB_RESOLUTION_NO_PROBLEMS');
    }
    // const perc = value.sToFixed(1);
    const nReportedPb = i18n.tc('message.N_PROBLEMS_REPORTED', nReported, { nb: nReported });
    const nResolvedPb = i18n.tc('message.N_PROBLEMS_RESOLVED', nResolved, { nb: nResolved });
    return i18n.t('message.VH_PB_RESOLUTION_TEXT', { nReportedPb, nResolvedPb });
  },
});
